import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin, Facebook } from "lucide-react";
import { CONTACT_INFO } from "../mock";

const COMPANY = [
  { label: "About", to: "/about" },
  { label: "History", to: "/history" },
  { label: "Services", to: "/services" },
  { label: "Career", to: "/career" },
];
const BUSINESS = [
  { label: "Maruti Suzuki", to: "/services" },
  { label: "Hero MotoCorp", to: "/services" },
  { label: "Amaron Batteries", to: "/services" },
  { label: "Locations", to: "/locations" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0c1017] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="font-head font-extrabold text-2xl">
              <span className="text-[var(--rs-red)]">Rajiv</span>{" "}
              <span className="text-[#5b8cf0]">Syndicate</span>
            </span>
            <p className="text-white/55 text-sm leading-relaxed mt-4 max-w-xs">
              Authorised parts distributor for Maruti Suzuki, Amaron Batteries and Hero MotoCorp across Northern Haryana since 1996.
            </p>
            <div className="eyebrow muted mt-6" style={{ color: "#5b8cf0" }}>EST. 1996</div>
            <div className="flex gap-3 mt-6">
              <a
                href={CONTACT_INFO.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Rajiv Syndicate on LinkedIn"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#5b8cf0] hover:text-white transition-colors"
              >
                <Linkedin size={16} />
              </a>
              <a
                href={CONTACT_INFO.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Rajiv Syndicate on Facebook"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#5b8cf0] hover:text-white transition-colors"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-head font-semibold text-sm uppercase tracking-wider text-white/80 mb-5">Company</h4>
            <ul className="space-y-3">
              {COMPANY.map((i) => (
                <li key={i.label}>
                  <Link to={i.to} className="text-white/55 hover:text-white text-sm transition-colors">{i.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-head font-semibold text-sm uppercase tracking-wider text-white/80 mb-5">Business</h4>
            <ul className="space-y-3">
              {BUSINESS.map((i) => (
                <li key={i.label}>
                  <Link to={i.to} className="text-white/55 hover:text-white text-sm transition-colors">{i.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-head font-semibold text-sm uppercase tracking-wider text-white/80 mb-5">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3 text-white/55">
                <MapPin size={18} className="text-[#5b8cf0] shrink-0 mt-0.5" />
                <span>{CONTACT_INFO.address.join(" ")}</span>
              </li>
              <li className="flex gap-3 text-white/55">
                <Phone size={18} className="text-[#5b8cf0] shrink-0 mt-0.5" />
                <span>{CONTACT_INFO.accounts.join(" · ")}</span>
              </li>
              <li className="flex gap-3 text-white/55">
                <Mail size={18} className="text-[#5b8cf0] shrink-0 mt-0.5" />
                <a href={`mailto:${CONTACT_INFO.general}`} className="hover:text-white transition-colors break-all">{CONTACT_INFO.general}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-7 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/45 text-sm flex items-center gap-4 flex-wrap">
            <span>
              © {new Date().getFullYear()} Rajiv Syndicate Group.{" "}
              <Link to="/terms-and-conditions" className="hover:text-white transition-colors underline underline-offset-2">
                All rights reserved.
              </Link>
            </span>
            <Link to="/privacy-policy" className="hover:text-white transition-colors underline underline-offset-2">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-white transition-colors underline underline-offset-2">Terms and Conditions</Link>
          </p>
          <p className="text-white/45 text-xs font-mono-label uppercase tracking-widest">Ambala · Kurukshetra · Karnal · Yamuna Nagar</p>
        </div>
      </div>
    </footer>
  );
}
